module.exports = __webpack_public_path__ + "media/src/assets/images/img-free-online-consultation-55c930f927102768bcdc3e79f8069d02.png";